import { ArrowRight, Camera, MessageSquare, Sparkles } from 'lucide-react';

const AiBuilder = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4 md:px-8">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-primary-600 font-mono text-xs tracking-widest uppercase mb-4">AI Checklist Builder</h2>
          <h3 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-6">
            Answer a Few Questions.<br />
            <span className="text-gray-500">Get a Ready-to-Use Checklist Suite.</span>
          </h3>
          <p className="text-xl text-gray-500 leading-relaxed max-w-3xl mx-auto">
            No blank pages. Tell the AI about your restaurant—your equipment, sections, and routines—and it builds tailored opening, closing, and deep-clean checklists for you to review and publish.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          <div className="bg-gray-50 p-6 rounded-xl border border-gray-200">
            <MessageSquare className="text-primary-500 mb-4" size={28} />
            <h4 className="text-lg font-bold text-gray-900 mb-2">Chat-to-Checklist</h4>
            <p className="text-gray-600 text-sm">A short interview about your restaurant turns into a full checklist suite in minutes.</p>
          </div>

          <div className="bg-gray-50 p-6 rounded-xl border border-gray-200">
            <Camera className="text-primary-500 mb-4" size={28} />
            <h4 className="text-lg font-bold text-gray-900 mb-2">Photo-Walk Authoring</h4>
            <p className="text-gray-600 text-sm">Walk your store, capture reference photos, and the AI turns them into tasks.</p>
          </div>

          <div className="bg-gray-50 p-6 rounded-xl border border-gray-200">
            <Sparkles className="text-primary-500 mb-4" size={28} />
            <h4 className="text-lg font-bold text-gray-900 mb-2">Tuned to Your Restaurant</h4>
            <p className="text-gray-600 text-sm">Editable before you publish, so it always matches how your store actually runs.</p>
          </div>
        </div>

        <div className="text-center">
          <a
            href="https://app.shiftcheck.app/signup"
            className="inline-flex items-center justify-center gap-2 bg-primary-600 text-white border border-primary-500 px-8 py-4 rounded font-bold hover:bg-primary-700 transition-all"
          >
            Start Free Trial
            <ArrowRight size={18} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default AiBuilder;
